var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendChat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.987 3.775C28.854 3.218 28.242 2.839 27.687 3.036C27.687 3.036 3.646 11.521 3.642 11.524C3.273 11.661 3.002 12.013 2.982 12.416C2.964 12.803 3.203 13.206 3.556 13.37L12.868 17.717C12.868 17.717 17.405 13.18 17.413 13.172C18.313 12.272 19.75 13.664 18.827 14.586L14.282 19.131C14.282 19.131 18.623 28.433 18.631 28.448C18.808 28.788 19.154 29.004 19.534 29.021C19.947 29.04 20.329 28.724 20.477 28.354C20.477 28.354 28.957 4.327 28.962 4.312C29.025 4.139 29.029 3.952 28.987 3.775Z",
    fill: "#003893"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChat2);
export default __webpack_public_path__ + "static/media/send_chat_2.ae1eb4fc5e16354739c1c853aa06e7f5.svg";
export { ForwardRef as ReactComponent };